import React from "react";
import { Container, SecondaryButton } from "@prestosports/commons-ui";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import { Toolbar } from "@material-ui/core";
import commonStyles from "../styles/Common.styles";
import startImportContainerStyles from "../styles/StartImportContainer.styles";
import { usePlayersContext } from "../../../state/players/context";

const StartImportContainer = ({ onCancel = () => {} }) => {
	const commonClasses = commonStyles();
	const classes = startImportContainerStyles();

	const { state } = usePlayersContext();
	const csvHeaders = state.csvHeaders();

	return (
		<Container fullHeight noPaper>
			<Box className={commonClasses.container}>
				<Box className={commonClasses.form}>
					<Grid container className={classes.detailsContainer}>
						<Grid item md={12}>
							<pre className={classes.pre}>{csvHeaders}</pre>
						</Grid>
					</Grid>
					<Toolbar className={commonClasses.actionToolbar}>
						<Grid container direction="row" justifyContent="flex-end" spacing={2}>
							<Grid item>
								<SecondaryButton color="secondary" label="Cancel" onClick={onCancel} />
							</Grid>
						</Grid>
					</Toolbar>
				</Box>
			</Box>
		</Container>
	);
};

export default StartImportContainer;
